import { render, staticRenderFns } from "./InvitationAuthenticated.vue?vue&type=template&id=67cf8dcc&"
import script from "./InvitationAuthenticated.vue?vue&type=script&lang=js&"
export * from "./InvitationAuthenticated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports